var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 53,
    viewBox: "0 0 57 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_2927)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4517 2.82861C47.1762 2.82861 48.5282 2.8286 49.6148 2.91739C50.7213 3.00779 51.6354 3.19493 52.4628 3.61651C53.823 4.30956 54.9289 5.41542 55.6219 6.77561C56.0435 7.603 56.2307 8.51711 56.3211 9.62361C56.4098 10.7102 56.4098 12.0622 56.4098 13.7866V13.8712C56.4098 15.5956 56.4098 16.9477 56.3211 18.0343C56.2307 19.1408 56.0435 20.0549 55.6219 20.8823C54.9289 22.2425 53.823 23.3484 52.4628 24.0414C51.6354 24.463 50.7213 24.6502 49.6148 24.7406C48.5282 24.8293 47.1763 24.8293 45.4519 24.8293H42.5808V27.135C43.3658 27.1898 44.1471 27.3134 44.9157 27.5055L46.8953 28.0004C47.4005 28.1267 47.7077 28.6387 47.5814 29.1439C47.4551 29.6491 46.9432 29.9562 46.438 29.8299L44.4584 29.335C43.5325 29.1035 42.5852 28.9878 41.6379 28.9878C40.6906 28.9878 39.7434 29.1035 38.8175 29.335L36.8379 29.8299C36.3327 29.9562 35.8207 29.6491 35.6945 29.1439C35.5682 28.6387 35.8753 28.1267 36.3805 28.0004L38.3601 27.5055C39.1288 27.3134 39.9101 27.1898 40.695 27.135V24.8293H37.8241C36.0997 24.8293 34.7476 24.8293 33.661 24.7406C32.5545 24.6502 31.6404 24.463 30.813 24.0414C29.4528 23.3484 28.347 22.2425 27.6539 20.8823C27.2323 20.0549 27.0452 19.1408 26.9548 18.0343C26.866 16.9477 26.866 15.5957 26.866 13.8712V13.7868C26.866 12.0623 26.866 10.7103 26.9548 9.62361C27.0452 8.51711 27.2323 7.603 27.6539 6.77561C28.347 5.41542 29.4528 4.30956 30.813 3.61651C31.6404 3.19493 32.5545 3.00779 33.661 2.91739C34.7477 2.8286 36.0997 2.82861 37.8242 2.82861H45.4517ZM40.695 20.1149C40.695 20.6356 41.1172 21.0578 41.6379 21.0578L49.181 21.0578C49.7018 21.0578 50.1239 20.6356 50.1239 20.1149C50.1239 19.5941 49.7018 19.172 49.181 19.172H41.6379C41.1172 19.172 40.695 19.5942 40.695 20.1149ZM36.6092 20.1149C36.6092 20.8092 36.0463 21.3721 35.352 21.3721C34.6577 21.3721 34.0948 20.8092 34.0948 20.1149C34.0948 19.4206 34.6577 18.8577 35.352 18.8577C36.0463 18.8577 36.6092 19.4206 36.6092 20.1149Z",
    fill: "#FFA007"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_53_2927)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_53_2927)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2399 6.63794C32.9991 6.63793 35.1624 6.63792 36.901 6.77998C38.6714 6.92462 40.134 7.22405 41.4578 7.89857C43.6341 9.00745 45.4035 10.7768 46.5124 12.9531C47.1869 14.277 47.4863 15.7395 47.6309 17.5099C47.773 19.2485 47.773 21.4117 47.773 24.1707V24.3062C47.773 27.0652 47.773 29.2286 47.6309 30.9671C47.4863 32.7375 47.1869 34.2001 46.5124 35.5239C45.4035 37.7002 43.6341 39.4696 41.4578 40.5785C40.134 41.253 38.6714 41.5524 36.901 41.6971C35.1624 41.8391 32.9993 41.8391 30.2402 41.8391H25.6465V45.5281C26.9025 45.6159 28.1526 45.8136 29.3824 46.121L32.5498 46.9129C33.3581 47.115 33.8496 47.934 33.6475 48.7423C33.4454 49.5507 32.6263 50.0421 31.818 49.84L28.6506 49.0482C27.1692 48.6778 25.6536 48.4926 24.1379 48.4926C22.6223 48.4926 21.1067 48.6778 19.6252 49.0482L16.4578 49.84C15.6495 50.0421 14.8304 49.5507 14.6284 48.7423C14.4263 47.934 14.9177 47.115 15.7261 46.9129L18.8934 46.121C20.1233 45.8136 21.3734 45.6159 22.6293 45.5281V41.8391H18.0358C15.2768 41.8391 13.1134 41.8391 11.3749 41.6971C9.60447 41.5524 8.14189 41.253 6.81806 40.5785C4.64177 39.4696 2.87238 37.7002 1.7635 35.5239C1.08898 34.2001 0.789552 32.7375 0.644904 30.9671C0.502852 29.2285 0.50286 27.0652 0.502869 24.306V24.171C0.50286 21.4118 0.502852 19.2486 0.644904 17.5099C0.789552 15.7395 1.08898 14.277 1.7635 12.9531C2.87238 10.7768 4.64177 9.00745 6.81806 7.89857C8.14189 7.22405 9.60447 6.92462 11.3749 6.77998C13.1135 6.63792 15.2767 6.63793 18.0359 6.63794H30.2399Z",
    fill: "#FDC469"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2399 6.63794C32.9991 6.63793 35.1624 6.63792 36.901 6.77998C38.6714 6.92462 40.134 7.22405 41.4578 7.89857C43.6341 9.00745 45.4035 10.7768 46.5124 12.9531C47.1869 14.277 47.4863 15.7395 47.6309 17.5099C47.773 19.2485 47.773 21.4117 47.773 24.1707V24.3062C47.773 27.0652 47.773 29.2286 47.6309 30.9671C47.4863 32.7375 47.1869 34.2001 46.5124 35.5239C45.4035 37.7002 43.6341 39.4696 41.4578 40.5785C40.134 41.253 38.6714 41.5524 36.901 41.6971C35.1624 41.8391 32.9993 41.8391 30.2402 41.8391H25.6465V45.5281C26.9025 45.6159 28.1526 45.8136 29.3824 46.121L32.5498 46.9129C33.3581 47.115 33.8496 47.934 33.6475 48.7423C33.4454 49.5507 32.6263 50.0421 31.818 49.84L28.6506 49.0482C27.1692 48.6778 25.6536 48.4926 24.1379 48.4926C22.6223 48.4926 21.1067 48.6778 19.6252 49.0482L16.4578 49.84C15.6495 50.0421 14.8304 49.5507 14.6284 48.7423C14.4263 47.934 14.9177 47.115 15.7261 46.9129L18.8934 46.121C20.1233 45.8136 21.3734 45.6159 22.6293 45.5281V41.8391H18.0358C15.2768 41.8391 13.1134 41.8391 11.3749 41.6971C9.60447 41.5524 8.14189 41.253 6.81806 40.5785C4.64177 39.4696 2.87238 37.7002 1.7635 35.5239C1.08898 34.2001 0.789552 32.7375 0.644904 30.9671C0.502852 29.2285 0.50286 27.0652 0.502869 24.306V24.171C0.50286 21.4118 0.502852 19.2486 0.644904 17.5099C0.789552 15.7395 1.08898 14.277 1.7635 12.9531C2.87238 10.7768 4.64177 9.00745 6.81806 7.89857C8.14189 7.22405 9.60447 6.92462 11.3749 6.77998C13.1135 6.63792 15.2767 6.63793 18.0359 6.63794H30.2399Z",
    stroke: "url(#paint0_linear_53_2927)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_53_2927)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6293 34.2959C22.6293 35.1291 23.3047 35.8045 24.1379 35.8045L36.2069 35.8045C37.0401 35.8045 37.7155 35.1291 37.7155 34.2959C37.7155 33.4627 37.0401 32.7873 36.2069 32.7873L24.1379 32.7873C23.3047 32.7873 22.6293 33.4627 22.6293 34.2959ZM16.0919 34.2959C16.0919 35.4068 15.1914 36.3074 14.0804 36.3074C12.9695 36.3074 12.069 35.4068 12.069 34.2959C12.069 33.185 12.9695 32.2844 14.0804 32.2844C15.1914 32.2844 16.0919 33.185 16.0919 34.2959Z",
    fill: "url(#paint1_linear_53_2927)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_53_2927",
    x: -24.2471,
    y: -18.1121,
    width: 96.7701,
    height: 92.7476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_53_2927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_53_2927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_53_2927",
    x: 8.81312,
    y: 29.0286,
    width: 38.6699,
    height: 17.0463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.25583,
    dy: 3.25583
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25583
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.431373 0 0 0 0 0.156863 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53_2927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_53_2927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_2927",
    x1: 0.502869,
    y1: 6.63794,
    x2: 43.6056,
    y2: 53.7021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_2927",
    x1: 25.1082,
    y1: 37.1645,
    x2: 26.8412,
    y2: 26.3349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_2927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.1724,
    height: 30.1724,
    fill: "white",
    transform: "translate(26.5517)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_53_2927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.2759,
    height: 48.2759,
    fill: "white",
    transform: "translate(0 4.22412)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay);
export default __webpack_public_path__ + "static/media/display.0a98287a9a71d71c6537abe570c042ec.svg";
export { ForwardRef as ReactComponent };